export default [
    {
        title: 'Sports Massage',
        price: '$75',
        time: '60 minutes',
    }, 
    {
        title: 'Therapeutic Massage',
        price: '$75',
        time: '60 minutes',
    }, 
    {
        title: 'Relaxation Massage',
        price: '$75',
        time: '60 minutes',
    }, 
    {
        title: 'Sports (Pre/Post) Event Massage',
        price: '$75',
        time: '60 minutes',
    }, 
    {
        title: 'Compressible Limb Sleeve Therapy',
        price: '$30',
        time: '30 minutes',
    }, 
    {
        title: 'Trigger Point Therapy',
        price: '$95',
        time: '90 minutes',
    }, 
    {
        title: 'Strength Training',
        price: '$45',
        time: '45 minutes',
    }, 
    {
        title: 'Personal Training',
        price: '$45',
        time: '45 minutes',
    }, 
];